import { connect } from 'react-redux';
import { withTranslation } from '@piwikpro/ui-components';
import SearchCategoryAndQueryParams from './SearchCategoryAndQueryParams';

export type TagsInputValue = any[]

const mapStateToProps = (state: any, { t }: { t: any }) => {
  const appSearchQueryParams: TagsInputValue = state.trackerSettings.app.settings
    .attributes.site_search_query_params || [];
  const appSearchCategoryParams: TagsInputValue = state.trackerSettings.app.settings
    .attributes.site_search_category_params || [];
  const globalSearchQueryParams: TagsInputValue = (
    state.trackerSettings.global.settings
      .attributes.site_search_query_params || []
  )
    .map(
      (element: any) => ({
        value: element,
        disabled: true,
        tooltip: {
          content: t('apps.details.settings.globals.tooltip.content'),
        },
      }),
    );
  const globalSearchCategoryParams: TagsInputValue = (
    state.trackerSettings.global.settings
      .attributes.site_search_category_params || []
  )
    .map(
      (element: any) => ({
        value: element,
        disabled: true,
        tooltip: {
          content: t('apps.details.settings.globals.tooltip.content'),
        },
      }),
    );

  const globalAndAppSearchQueryTrackerSettings = [
    ...globalSearchQueryParams,
    ...appSearchQueryParams,
  ];
  const globalAndAppSearchCategoryTrackerSettings = [
    ...globalSearchCategoryParams,
    ...appSearchCategoryParams,
  ];

  return {
    globalAndAppSearchQueryTrackerSettings,
    globalAndAppSearchCategoryTrackerSettings,
    appSearchQueryTrackerSettings: appSearchQueryParams,
    appSearchCategoryTrackerSettings: appSearchCategoryParams,
  };
};

export default withTranslation(['administration'])(connect(mapStateToProps, null)(SearchCategoryAndQueryParams));
